/**
 * Tailwind default breakpoint scale in px, matching the `sm:`…`2xl:` variants.
 * Static mirror of the defaults: does not track `--breakpoint-*` overrides.
 */
export const BREAKPOINTS_PX = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536
} as const
